import React, { useState, useEffect, useRef } from "react";

type AddressResult = {
  place_id: number;
  display_name: string;
  lat: string;
  lon: string;
  address?: Record<string, any>;
};

type Props = {
  value: string;
  onChange: (val: string, result?: AddressResult) => void;
};

export const AddressAutocomplete: React.FC<Props> = ({ value, onChange }) => {
  const [query, setQuery] = useState(value);
  const [results, setResults] = useState<AddressResult[]>([]);
  const [open, setOpen] = useState(false);
  const abortRef = useRef<AbortController | null>(null);
  const [manualSelect, setManualSelect] = useState(false);

  useEffect(() => {
    if (manualSelect) {
      setManualSelect(false);
      return;
    }
  
    if (!query.trim()) {
      setResults([]);
      setOpen(false);
      return;
    }
  
    const timeout = setTimeout(() => fetchResults(query), 300);
    return () => clearTimeout(timeout);
  }, [query]);

  const fetchResults = (q: string) => {
    if (abortRef.current) abortRef.current.abort();
    const controller = new AbortController();
    abortRef.current = controller;

    fetch(
      `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(
        q
      )}&format=jsonv2&addressdetails=1&limit=5&countrycodes=fr`,
      {
        signal: controller.signal,
        headers: {
          "User-Agent": "ReactApp/1.0 (contact@example.com)",
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setResults(data);
        setOpen(true);
      })
      .catch((err) => {
        if (err.name !== "AbortError") console.error(err);
      });
  };

  const handleSelect = (r: AddressResult) => {
    setManualSelect(true);
    setQuery(r.display_name);
    setOpen(false);
    setResults([]);
    onChange(r.display_name, r);
  };
  
  return (
    <div className="relative w-full">
      <input
        type="text"
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          onChange(e.target.value);
        }}
        placeholder="Saisir une adresse..."
        className=" my-5 border border-gray-300 text-gray-900 text-md font-normal rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 block w-full p-2.5 "
      />
      {open && results.length > 0 && (
        <ul className="absolute z-50 w-full bg-white border rounded mt-1 max-h-60 overflow-auto shadow-lg">
          {results.map((r) => (
            <li
              key={r.place_id}
              className="cursor-pointer px-3 py-2 hover:bg-gray-100"
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => handleSelect(r)}
            >
              {r.display_name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
